import {
  IconButton,
  IconColor,
  IconName,
  IconSize,
  TipPlacement,
  Tooltip
} from '@focaldata/cin-ui-components'
import { FC } from 'react'
import useStyles from './KpiIndicatorIcon.styles'
import { KpiSign } from './kpiMarkers'

const SIGN: Record<KpiSign, string> = { positive: '+', negative: '\u2212' }

interface Props {
  lines: string[]
  sign?: KpiSign
  isSubject?: boolean
  onClick: () => void
}

const KpiIndicatorIcon: FC<Props> = ({ lines, sign, isSubject, onClick }) => {
  const { classes } = useStyles()

  if (lines.length === 0) {
    return null
  }

  return (
    <Tooltip
      tipPlacement={TipPlacement.Left}
      title={
        lines.length === 1 ? (
          lines[0]
        ) : (
          <span className={classes.tooltip}>
            {lines.map((line, index) => (
              // Two KPIs may share a name, so the line itself isn't a unique key.
              <span key={index}>{line}</span>
            ))}
          </span>
        )
      }
    >
      <span className={classes.trigger}>
        <IconButton
          iconName={IconName.Kpi}
          iconSize={IconSize.Large}
          iconColor={IconColor.Emphasis}
          text={isSubject ? 'KPI' : sign && SIGN[sign]}
          ariaLabel={lines.join('. ')}
          onClick={onClick}
          smallHoverShadowSize
        />
      </span>
    </Tooltip>
  )
}

export default KpiIndicatorIcon
